import { AllNumbers } from '@/components/AllNumbers/AllNumbers.tsx';
import { MainBlock } from '@/components/MainBlock/MainBlock.tsx';
import { tryFlushAndroidCookies } from '@/utils';

export function HomePage() {
    const url = new URL(window.location.href);

    if (url.search.includes('ref')) {
        const params = new URLSearchParams(url.search);
        document.cookie = `ref=${params.get('ref')}`;
        window.history.replaceState(null, '', window.location.origin);
        tryFlushAndroidCookies();
    }

    return (
        <>
            <MainBlock />
            <AllNumbers />
        </>
    );
}
